import styled from '@emotion/styled';
import { Button } from '@smartsheet/lodestar-core';

export const IconButton = styled(Button)`
  &&:before {
    content: none;
  }
`;
